import { render } from "./DetalheFichaEpisLegado.vue?vue&type=template&id=cb6fe18e"
import script from "./DetalheFichaEpisLegado.vue?vue&type=script&lang=js"
export * from "./DetalheFichaEpisLegado.vue?vue&type=script&lang=js"

import "./DetalheFichaEpisLegado.vue?vue&type=style&index=0&id=cb6fe18e&lang=sass"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QImg,QTable,QTd});
